import { IFilterComplete } from "src/app/filter-complete/filter-complete";

export class MedicalAppointmentWaitState implements IFilterComplete {
    Id: number;
    Name: string;
}

export enum EstadoTurnoEspera {
  EnEspera = 1,
  TurnoGenerado = 2,
  Desestimar = 3,
  SinRespuesta = 4
}
